module.exports = __webpack_public_path__ + "static/media/f1.348f5a2b.jpg";